import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IUtilityCustomerFilterSelectProps {
    value: (number | string)[] | undefined;
    onChange: (value: (number | string)[]) => void;
    options: ISelectOption<number | string>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const UtilityCustomerFilterSelect: React.FC<IUtilityCustomerFilterSelectProps> = ({
    disabled = false,
    value = [],
    onChange,
    label,
    options,
    isLoading,
}) => {
    return (
        <BaseFilterCheckboxSelect
            resizable
            searchable
            multiple
            selectedCountInLabel
            showSelectAllOption={false}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={300}
        />
    );
};
